import { useEffect, useRef, useState } from "react";

export function useIsSmall(breakpoint = 500) {
  const ref = useRef(null);
  const [isSmall, setIsSmall] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      setIsSmall(width < breakpoint);
    });

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [breakpoint]);

  return { ref, isSmall };
}
